import { render } from "./MascotLogo.vue?vue&type=template&id=4cb1525e"
import script from "./MascotLogo.vue?vue&type=script&lang=js"
export * from "./MascotLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__